import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface RevertRevisionData {
  uuid: string;
  revisionId: string;
}

interface RevertRevisionResponse {
  data: any;
}

export function useRevertRevision() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async ({
      uuid,
      revisionId,
    }: RevertRevisionData): Promise<RevertRevisionResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/revert_revision`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({ agentUuid: uuid, revisionId }),
        }
      );

      const data = await response.json();

      return {
        data: data?.data,
      };
    },
  });
}
